import {createSelector} from 'reselect';
import props from '../../../../props';

export default createSelector(
    props.wallet.methods.applepay_deposit,
    (applepay_deposit) => {
        return {
            stage: applepay_deposit.stage
        }
    }
)